// extracted by mini-css-extract-plugin
export default {"white":"styles_white__IMoI9","diff":"styles_diff__Xkbyf","tooltip":"styles_tooltip__JJ9gJ"};